module.exports = __webpack_public_path__ + "img/icon-3.3f5744a1.svg";